export const transactionFilterState = () => ({
  searchKey: '',
  page: 1,
  perPage: 10,
  orderBy: 'createdAt',
  order: 'asc'
});
